<template>
  <div id="navigation">
    <ul class="nav_ul">
      <li v-for="(item, index) in Menus" 
      :key="index"     
      >
        <a @click="SET_MENUID(item.power_id)">{{ item.power_title }}</a>
      </li>
      <!-- <li>關於中心</li>
      <li>團隊介紹</li>
      <li>服務內容</li>
      <li>最新消息</li>
      <li>衛教專區</li>
      <li>資源連結</li> -->
    </ul>
    <!-- <div v-else>無資料</div> -->
  </div>
</template>

<script>
import api from "../utils/apis/DepApi.js";
import { mapMutations } from 'vuex';
export default {
  name: "Navigation",

  data: () => ({  
    Menus: [],   
  }),

  mounted() {
    this.getMenuInf();
  },
  methods: {
  ...mapMutations([
            'SET_MENUDATA', 'SET_MENUID'
          ]),          
   getMenuInf() {
      //   this.loading = true;
      api
        .CtrMenu()
        .then(
          (response) => (
             (this.Menus = response.data.Data, this.SET_MENUDATA(response.data.Data))
          )
        )
        .catch( err => console.log(err))
        .finally();       
    },
  },
};
</script>

<style lang="scss" scoped>
#navigation {
    float: right;
    margin: 0;
    padding-top:50px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;

  ul.nav_ul {    
     display: flex;

    li{
        position: relative;
        width: 120px;
    }

    li a {
     transition: all .2s;
    text-align: center;
    display: block;  
    letter-spacing: 2px;
    padding: 4px 10px;
    font-size: 1.2rem;
    // font-weight:bold;
    position: relative;
    box-sizing: border-box;
    -moz-transition: all 0.8s ease;
    -o-transition: all 0.8s ease;
    -webkit-transition: all 0.8s ease;
    transition: all 0.8s ease;
    position: relative;
    top: 0;
    transition: all .3s ease;
    }

    // &:hover {
    //   color: #7ca971;
    // }
    li.active>a, li:hover>a {
       top: -10px;
    color: #f4a49f;
     display: block;
     cursor:pointer;  
    }

li>a:before{
    content: '';
    display: block;
    height:0;
    width: 1px;
    position: absolute;
    bottom: -15px;
    left: 50%;
    transition: all .3s ease;
    background: #ed8389;
        z-index: 1;
      }

      li.active>a:before,
      li.active2>a:before,
      li:hover>a:before{
          height: 14px;  
      }        
  }
}
@media (max-width: 1024px) {
    ul.nav_ul {    
     display: flex;
    li{
        position: relative;
        width: 100px !important;
    }
    li a {  
    padding: 4px 10px  !important;
    font-size: 1rem  !important;     
    }  
}
}
</style>
